import React, { useEffect, useRef, useState } from "react";
import { FilePond as IFilePond, registerPlugin } from "react-filepond";
import { useDispatch, useSelector } from "react-redux";
import { clearUploadStatus, uploadFiles } from "@store/actions/pdf";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { getUploadStatus } from "@store/selectors/upload";
import { Alert, Button, ButtonGroup, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import { PdfGenerator, PdfTypes, UploadJobType } from "@utils/enums";
import SpinnerLoader from "@components/SpinnerLoader/SpinnerLoader";
import clx from "classnames";
import DropdownSelect from "@components/DropdownSelect/DropdownSelect";
registerPlugin(FilePondPluginFileEncode, FilePondPluginImagePreview);
const conversionTypesMapping = {
    [UploadJobType.ONE_BY_ONE]: "One by one",
    [UploadJobType.ALL_TO_ONE]: "All files to one PDF"
};
const conversionTypes = [UploadJobType.ONE_BY_ONE, UploadJobType.ALL_TO_ONE];
const UploadDocuments = () => {
    const [pdfGenerationOptions, setPdfGenerationOptions] = useState({});
    const [isSendingFiles, setSendingFilesStatus] = useState(false);
    const [alertVisibility, setAlertVisibility] = useState(false);
    const uploadStatus = useSelector(getUploadStatus);
    const [files, setFiles] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        if (uploadStatus && pondRef.current) {
            pondRef.current.removeFiles();
            setFiles([]);
        }
        if (uploadStatus !== null) {
            setAlertVisibility(true);
        }
    }, [uploadStatus]);
    useEffect(() => {
        if (uploadStatus && files.length === 0) {
            setSendingFilesStatus(false);
        }
    }, [files]);
    useEffect(() => {
        return () => {
            dispatch(clearUploadStatus());
        };
    }, []);
    const [isPrepared, setPrepareStatus] = useState(false);
    const [jobType, setJobType] = useState(UploadJobType.ONE_BY_ONE);
    const pondRef = useRef();
    const FilePond = IFilePond;
    const handleUpload = () => {
        setPrepareStatus(false);
        setSendingFilesStatus(true);
        const uploadedFiles = pondRef.current ? pondRef.current.getFiles() : [];
        const attachments = uploadedFiles.map((singleFile) => ({
            content: singleFile.getFileEncodeBase64String(),
            name: singleFile.filename
        }));
        dispatch(uploadFiles({
            jobType,
            data: {
                jobId: "",
                performVirusScanning: true,
                attachments,
                ...pdfGenerationOptions
            }
        }));
    };
    const handleFileChange = (fileItems) => {
        setFiles(fileItems.map((fileItem) => fileItem.file));
    };
    const handleFileRemove = (error, fileToRemove) => {
        if (!pondRef.current) {
            return;
        }
        const filesAfterRemove = pondRef.current
            .getFiles()
            .filter(file => file.id !== fileToRemove.id);
        setFiles(filesAfterRemove.map(file => file.file));
        if (pondRef.current && pondRef.current.getFiles().length === 0) {
            setPrepareStatus(false);
        }
    };
    const onDropdownChange = (dropdown) => {
        if (dropdown[Object.keys(dropdown)[0]]) {
            setPdfGenerationOptions({
                ...pdfGenerationOptions,
                ...dropdown
            });
        }
    };
    const isButtonActive = (selectedJobType) => jobType === selectedJobType;
    return (React.createElement(Container, null,
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement("h5", null, "Conversion Type"))),
        React.createElement(Row, null,
            React.createElement(Col, { md: "auto", className: "mb-2" },
                React.createElement(ButtonGroup, null, conversionTypes.map((i) => (React.createElement(Button, { key: i, variant: isButtonActive(i) ? "primary" : "secondary", onClick: () => setJobType(i), active: isButtonActive(i) }, conversionTypesMapping[i]))))),
            React.createElement(Col, { className: "d-flex justify-content-md-end mb-2" },
                React.createElement(DropdownSelect, { onDropdownSelect: onDropdownChange, options: Object.keys(PdfTypes).map(item => item), dropdownName: "pdf-types", dropdownPlaceholder: "Select PDF Type", dropdownKey: "pdfType" })),
            React.createElement(Col, { md: "auto", className: "mb-2" },
                React.createElement(DropdownSelect, { onDropdownSelect: onDropdownChange, options: Object.keys(PdfGenerator).map(item => item), dropdownName: "pdf-generators", dropdownPlaceholder: "Select PDF Generator", dropdownKey: "pdfGenerator" }))),
        uploadStatus && uploadStatus.uploaded && (React.createElement(Alert, { variant: "success", show: alertVisibility, onClose: () => setAlertVisibility(!alertVisibility), dismissible: true },
            uploadStatus.message,
            " ",
            React.createElement(Link, { to: `/job/${uploadStatus.jobId}` },
                "See your job: ",
                uploadStatus.jobId))),
        uploadStatus &&
            !uploadStatus.uploaded &&
            uploadStatus.uploaded !== null && (React.createElement(Alert, { variant: "danger", show: alertVisibility, onClose: () => setAlertVisibility(!alertVisibility), dismissible: true }, uploadStatus.message)),
        isSendingFiles && React.createElement(SpinnerLoader, null),
        React.createElement("div", { className: clx({ "d-none": isSendingFiles }) },
            React.createElement(FilePond, { ref: pondRef, instantUpload: false, files: files, allowMultiple: true, allowRevert: false, onupdatefiles: handleFileChange, onpreparefile: () => setPrepareStatus(true), onremovefile: handleFileRemove })),
        React.createElement(Button, { disabled: !isPrepared, onClick: () => handleUpload(), color: "primary" }, "Upload")));
};
export default UploadDocuments;
